// @flow
import React from 'react';

type T_GAME_MODULE_NAME = 'GAME_MODULE';
const GAME_MODULE_NAME: T_GAME_MODULE_NAME = 'GAME_MODULE';

const CONSOLE_SETTINGS_MODAL = 'CONSOLE_SETTINGS_MODAL';

const betRefs = {
    safe: React.createRef(),
    safeDone: React.createRef(),
    threat: React.createRef(),
    threatDone: React.createRef(),
};
const MobileVersionContext = React.createContext<T>((false: T));

const GAME_INFO_SECTION = 'GAME_INFO_SECTION';
const GAME_INFO_RATING = 'GAME_INFO_RATING';
const GAME_INFO_BET = 'GAME_INFO_BET';

type T_MODAL_GAME_PAUSE = 'MODAL_GAME_PAUSE';
const MODAL_GAME_PAUSE: T_MODAL_GAME_PAUSE = 'MODAL_GAME_PAUSE';

const KEY_COOKIE_BANNER = 'KEY_COOKIE_BANNER';

export {
    GAME_MODULE_NAME,
    GAME_INFO_SECTION,
    GAME_INFO_RATING,
    GAME_INFO_BET,
    CONSOLE_SETTINGS_MODAL,
    betRefs,
    MODAL_GAME_PAUSE,
    MobileVersionContext,
    KEY_COOKIE_BANNER
};
export type {T_GAME_MODULE_NAME, T_MODAL_GAME_PAUSE};
